<div class="application-layout">
    <router-outlet></router-outlet>
</div>
